const name = 'DropIn';
const properties = {
    hideOnStart: true,
    viewportThreshold: 0.15,
    groups: ['entrance', 'animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        power: {
            type: 'string',
            enum: ['soft', 'medium', 'hard'],
            default: 'hard',
        },
    },
};
const scaleMap = {
    soft: 1.2,
    medium: 3.6,
    hard: 6,
};
function animate(kit, elements, duration, delay, { power = properties.schema.power.default, ...params } = {}) {
    const sequence = kit.sequence(params);
    const scale = scaleMap[power];
    sequence.add([
        kit.animate('BaseFade', elements, duration * 0.25, delay, {
            from: { opacity: 0 },
            to: { opacity: 1 },
            ease: 'Sine.easeIn',
        }),
        kit.animate('BaseScale', elements, duration, delay, {
            from: { scale },
            ease: 'Sine.easeIn',
        }),
    ]);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=dropIn.js.map